import _Placeholder from './Placeholder';

import './style/index.js';

export * from './type';

export const Placeholder = _Placeholder;

export default Placeholder;
